import templateUrl from "emun.order/parts/parts-order-container.htm";
import listTemplateUrl from "emun.order/parts/parts-order-list.htm";
import controller from "emun.order/parts/parts-order-container.controller";

const isList = (type = "") => type === "list" || type === "mutli-view";

export default {
    bindings: {
        ngModel: "=?",
        retailerId: "<?",
        productId: "<?",
        hideHeader: "@",
        detailSref: "@",
        disableQueryString: "<"
    },
    controller,
    templateUrl($element, $attrs) {
        return (
            $attrs.templateUrl ||
            (isList($attrs.type) ? listTemplateUrl : templateUrl)
        );
    }
};
